import { createContext, useContext } from "react";

import type { AvatarRadius, AvatarSize } from "./Avatar.types";

export type AvatarGroupContextValue = {
  size?: AvatarSize;
  radius?: AvatarRadius;
};

export const AvatarGroupContext = createContext<
  AvatarGroupContextValue | undefined
>(undefined);

export function useAvatarGroupContext() {
  return useContext(AvatarGroupContext);
}
